import { playgroundHighlights } from '@/mocks/playgroundData';
import { useInView } from '@/hooks/useInView';

function StripItem({ item, delay }: { item: typeof playgroundHighlights[0]; delay: number }) {
  const [ref, inView] = useInView<HTMLDivElement>();

  return (
    <div
      ref={ref}
      className={`flex items-start gap-3 transition-all duration-700 ${
        inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-5'
      }`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      <div className="w-11 h-11 shrink-0 flex items-center justify-center rounded-xl bg-background-100 text-primary-600 border border-background-200/70">
        <i className={`${item.icon} text-xl`} />
      </div>
      <div>
        <h3 className="text-sm font-semibold text-foreground-900 mb-1">{item.title}</h3>
        <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.description}</p>
      </div>
    </div>
  );
}

export default function FeatureStrip() {
  return (
    <section className="w-full px-4 md:px-8 lg:px-12 pb-14 md:pb-20">
      <div className="rounded-2xl bg-background-100 border border-background-200/70 p-6 md:p-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {playgroundHighlights.map((item, i) => (
            <StripItem key={item.id} item={item} delay={i * 90} />
          ))}
        </div>
      </div>
    </section>
  );
}